<template>

<article class="form-success-modal">
        <div
            class="form-success-modal__overlay"
            @click="$emit('hideModal')"></div>
        <div class="form-success-modal__wrapper">
            <button
                class="form-success-modal__hide"
                aria-label="Закрыть модальное окно"
                @click.prevent="$emit('hideModal')"></button>
            <div class="form-success-modal__img">
                <img
                    src="/static/v2/src/img/urban/derbent/icons/form-success.svg"
                    alt="Форма успешно отправлена"
                    title="Форма успешно отправлена"
                    width="80"
                    height="82" />
            </div>
            <h3
                class="form-success-modal__title"
                :title="title"
                v-html="title"></h3>
            <p
                class="form-success-modal__desc"
                v-html="description"></p>
            <button
                class="form-success-modal__btn"
                aria-label="Закрыть модальное окно"
                @click.prevent="$emit('hideModal')">
                Закрыть
            </button>
        </div>
    </article>
</template>

<script>
    export default {
        name: 'FormSuccessModal',
        props: {
            title: {
                type: String,
                default: ''
            },
            description: {
                type: String,
                default: ''
            }
        }
    }
</script>